import React, { useState, useEffect } from "react";
import "./Information.css";
// import { bulletin_info } from "../../constants/bulletin_board";
import axios from "axios";
const Information = () => {

  const [bulletin_info, setBulletins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBulletins();
  }, []);

  const fetchBulletins = async () => {
    try {
      const res = await axios.get("/backend/bulletin/public");
      const data = res.data;

      if (!Array.isArray(data)) {
        console.error("Invalid data format:", data);
        setBulletins([]);
        return;
      }
      setBulletins(data);
    } catch (err) {
      console.error("Error fetching bulletin:", err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="important">
      <div className="bulletin">
        <div className="board">Bulletin Board</div>
        <div className="line"></div>
        <div
          className="list"
          onMouseOver={(e) => handleMouseOver(e)}
          onMouseOut={(e) => handleMouseOut(e)}
        >
          <ul className="scroll-content">
            {loading ? (
              <li className="impmsg">Loading...</li>
            ) : bulletin_info.length === 0 ? (
              <li className="impmsg">No Announcements Available</li>
            ) : (
              bulletin_info.map((item) => (
                <li className="msg" key={item.link}>
                  <a
                    className="impmsg"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    {/* {item.content} */}
                    {item.is_new === 1 ? (
                      <>
                        <span className="newContent">New</span>{" "}
                        <span className="insideNewContent">
                          {item.content}
                        </span>
                      </>
                    ) : (
                      <span className="insideNewContent">
                        {item.content}
                      </span>
                    )}
                  </a>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
      <div className="quick">
        <a
          href="https://www.tneaonline.org"
          target="blank"
          className="quick-link"
        >
          Admission
        </a>
        <a
          href="library"
          target="blank"
          className="quick-link"
        >
          ACCET Library
        </a>
        <a href="/coe" target="blank" className="quick-link">
          Controller of Examination
        </a>
        <a href="/scholarship" className="quick-link">
          Scholarships
        </a>
        <a href="/fee-structure" className="quick-link">
          Fee Structure
        </a>
      </div>
    </div>
  );
};

const handleMouseOver = (e) => {
  e.currentTarget.querySelector('.scroll-content').style.animationPlayState = 'paused';
};

const handleMouseOut = (e) => {
  e.currentTarget.querySelector('.scroll-content').style.animationPlayState = 'running';
};

export default Information;
